<template>
  <labeled-form-control label="Breed">
    <div v-if="breed" class="d-flex w-100">
      <input v-model="breed.name" class="form-control search-input" type="search" disabled/>
      <div class="form-control search-icon" @click="updateBreed({petId: petId, breedId: ''})" style="cursor: pointer !important">
        <i class="fas fa-eraser" ></i>
      </div>
    </div>
    <breed-search v-else :pet-id="petId" :validator="validator"/>
  </labeled-form-control>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { BreedCacheMixin } from '@/mixins/Booking/BreedCacheMixin'
import PetBreedSearchField from './PetBreedSearchField.vue'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetBreed',
  mixins: [BreedCacheMixin],
  props: {
    petId: {
      type: String,
      required: true
    },
    validator: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('ClientRegistrationUpload', [
      'pets'
    ]),
    pet () {
      return this.pets.find(p => p.id === this.petId)
    },
    breedId () {
      return this.pet?.breedId || ''
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updateBreed'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'breed-search': PetBreedSearchField
  }
}
</script>

<style scoped>
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.search-icon {
  width: max-content;
  padding: 0.375rem 0.75rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
